import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAdminAuth } from "@/context/AdminAuthContext";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, checkingSession } = useAdminAuth();

  if (checkingSession) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[color:hsl(var(--background))]">
        <Loader2 className="h-6 w-6 animate-spin text-[color:var(--brand-gold-2)]" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/yonetim/giris" replace />;
  }
  return children;
};

export default ProtectedRoute;

